import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, Route, RouterStateSnapshot } from '@angular/router';
import { AuthenticationService } from '@services/authentication.service';


/**
 * 
 */
@Injectable({ providedIn: 'root' })
export class AuthGuard  {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService
  ) { }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.isAuthorizedRet(state);
  }
  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.isAuthorizedRet(state);
  }

  canLoad(route: Route): boolean {
    return this.isAuthorized();
  }

  /**
   * Check if user is authorized. Redirect to login if not. Save returnUrl from state.
   * @param state The router state from which we store the url to return to.
   */
  private isAuthorizedRet(state: RouterStateSnapshot): boolean {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      // authorised so return true
      return true;
    }

    // not logged in so redirect to login page with the return url
    this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
    return false;
  }

  /**
   * Check if user is authorized. Redirect to login if not. Save returnUrl from state.
   */
  private isAuthorized(): boolean {
    const currentUser = this.authenticationService.currentUserValue;
    if (currentUser) {
      // authorised so return true
      return true;
    }

    // not logged in so redirect to login
    this.router.navigate(['/login']);
    return false;
  }
}
